export default __webpack_public_path__ + "static/media/oxyrich.8d94c08c.png";